import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss'],
})
export class SearchFilterComponent {
  @Input() label: string;
  @Input() placeholder: string;
  @Input() items: string[] = [];
  @Input() iconName: string;
  @Input() expanded: boolean = false;

  @Output() itemsChange = new EventEmitter<string[]>();

  @ViewChild('input') input: ElementRef;

  addOnBlur = true;
  inputControl = new FormControl();
  separatorKeysCodes: number[] = [ENTER, COMMA];

  remove(item: string): void {
    const index = this.items.indexOf(item);

    if (index >= 0) {
      this.items.splice(index, 1);
      this.itemsChange.emit(this.items);
    }
  }

  add(event: any): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      this.items.push(value.trim());
      this.itemsChange.emit(this.items);
    }

    if (input) {
      input.value = '';
    }

    this.inputControl.setValue(null);
  }
}
